export function escapeRegExp(str) {
  return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
}

export function makeUrl(base: string, endpoint: string): string {
  const baseHasSlash = base.endsWith('/');
  if (endpoint.startsWith('/')) {
    endpoint = endpoint.substring(1);
  }
  return `${base}${!baseHasSlash ? '/' : ''}${endpoint}`;
}
